import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';

import style from './style.module.scss';

export function SubmitButton(props) {
  return props.showSubmit ? (
    <div className={style.submitButtonWrapper}>
      <Button onClick={props.onClick}>{props.text}</Button>
    </div>
  ) : (
    <></>
  );
}

SubmitButton.propTypes = {
  /**
   * button text
   */
  text: PropTypes.string,
  /**
   * bool to show submit button
   */
  submitButton: PropTypes.bool,
  /**
   * function to invoke when button pressed
   */
  onClick: PropTypes.func,
};
